import { PrescriptionRepository } from '@/io/repository/PrescriptionRepository';
import { GeneratePrescriptionData } from '@/models/PrescriptionGenerationModel';
import { createMutation } from '@/queries/utils/CreateMutation.ts';

export class PrescriptionQueries {
  constructor(
    private readonly prescription: PrescriptionRepository = new PrescriptionRepository(),
  ) {}

  /*******************************/
  /*********** Mutation ***********/
  /*******************************/

  useGeneratePrescription = createMutation(
    'generate-prescription',
    async (data: GeneratePrescriptionData) =>
      this.prescription.generatePrescription(data),
  );

  useSignPrescription = createMutation(
    'sign-prescription',
    async (data: GeneratePrescriptionData) =>
      this.prescription.signPrescription(data),
  );
}
